module.exports = __webpack_public_path__ + "static/media/13.2bc7354f.mp3";